import { defineStore } from 'pinia'
import { ref } from 'vue'
import { router, usePage } from '@inertiajs/vue3'
import { useToastNotificationsStore } from '@/Stores/ToastNotificationsStore'

export const usePostStore = defineStore("post-store", () => {

	const post = ref(null);
	const user = ref(usePage().props.auth.user);
	const gorse = ref(usePage().props.gorse);
	const menuOpened = ref(false);
	const toastNotificationsStore = useToastNotificationsStore()

	const setCurrentPost = (current) => {
		post.value = current
	}
	const like_unlike = () => {
		if (!user.value) {
			router.visit(route('register'))
			return
		}

		let url = route('post.like', post.value.uuid)

		window.axios.post(url).then(response => {
			post.value.meta = response.data
		})
	}
	const dislike = () => {
		if (!user.value) {
			router.visit(route('register'))
			return
		}

		let url = route('post.dislike', post.value.uuid)

		window.axios.post(url).then(response => {
			post.value.meta = response.data

			toastNotificationsStore.add({
				message: "Post disliked.",
				type: "success"
			})
		})
	}
	const follow_unfollow = () => {
		if (user.value) {
			let url = route('creator.follow', post.value.creator.slug)
			window.axios.post(url).then(response => {

				post.value.creator.meta = response.data

				for (const [key, post] of Object.entries(usePage().props.posts.data)) {
					if (post.creator.id === post.creator.id) {
						post.creator.meta.following = response.data.following
					}
				}
			})
		} else {
			// signup
			router.visit(route('register'))
		}
	}
	const share = () => {

		const utm = {
			utm_source: import.meta.env.VITE_APP_NAME,          // or website name
			utm_medium: 'post_share_button',     // it was shared via a button
			utm_campaign: 'content_share',  // general share tracking
			utm_content: post.value.title    // unique post identifier
		}

		// Build URL with UTM querystring
		const shareUrl = new URL(post.value.url);
		Object.entries(utm).forEach(([key, value]) => {
			shareUrl.searchParams.set(key, value);
		});

		try {
			window.navigator.share({
				url: shareUrl.toString(),
				text: 'Check this awesome video',
				title: post.value.title
			})
		} catch (e) {
			navigator.clipboard.writeText(shareUrl.toString());

			toastNotificationsStore.add({
				message: 'link copied to clipboard',
				type: 'success'
			})
		}

		if (gorse.value.enabled) {
			window.axios.post(route('post.feedback', { post: post.value.uuid, feedback: 'share' }));
		}
	}

	const toggleMenu = (show = null) => {
		if (null === show) {
			menuOpened.value = !menuOpened.value
		} else {
			menuOpened.value = show
		}
	}

	return {
		post,
		menuOpened,
		setCurrentPost,
		toggleMenu,
		like_unlike,
		dislike,
		follow_unfollow,
		share
	};
});
